<template>
<div class="videos">
    <v-card>
      <v-toolbar dark flat color="primary">
        <v-toolbar-title>Materiały wideo</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="!showAdd && (isAdmin || isTrainer)" color="accent" @click="showAdd = true" dark>dodaj wideo</v-btn>
        <v-btn v-if="showAdd" flat small @click="showAdd = false">ukryj</v-btn>
      </v-toolbar>
    </v-card>
    <v-slide-y-transition>
      <v-card class="mt-2" v-if="showAdd">
        <v-container>
          <v-layout justify-center row>
            <v-flex sm8 md6 lg5>
              <video-form @success="showAdd = false; refresh()"></video-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-slide-y-transition>
    <v-card class="mt-2 pb-1">
      <v-data-iterator
        :items="videosList"
        :pagination.sync="context"
        :rows-per-page-items="perPageOptions"
        :total-items="rowsTotal"
        :loading="loading"
        content-tag="v-container"
        grid-list-xl
      >
        <v-layout slot="item" slot-scope="props" justify-center row>
        <v-flex
          xs12
          sm10
          md8
          lg6
        >
          <v-card>
            <video-item :video="props.item" @remove-video="removeVideo(props.item)"></video-item>
          </v-card>
        </v-flex>
        </v-layout>
      </v-data-iterator>
    </v-card>
</div>
</template>

<script>
import {fetchAdminVideo, fetchTrainerVideo, fetchRunnerVideo, deleteAdminVideo, deleteTrainerVideo} from './api'
import {ListMixin} from '@/utils/ListMixin'
import iziToast from 'izitoast'
import { mapGetters } from 'vuex'
import _ from 'lodash'

import VideoForm from './VideoForm'
import VideoItem from './VideoItem'

export default {
  components: {VideoForm, VideoItem},
  mixins: [ListMixin],
  data () {
    return {
      showAdd: false,
      loading: true,
      videosList: []
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isTrainer', 'trainer', 'runner'])
  },
  watch: {
    '$route': 'fetchVideoList',
    context: {
      handler () {
        this.fetchVideoList()
      },
      deep: true
    }
  },
  methods: {
    refresh: _.debounce(function () {
      this.fetchVideoList()
    }, 400),
    fetchVideoList () {
      this.loading = true
      let params = this.prepareParams()
      let promise
      if (this.isAdmin) {
        promise = fetchAdminVideo(params)
      } else if (this.isTrainer) {
        promise = fetchTrainerVideo(this.trainer, params)
      } else {
        promise = fetchRunnerVideo(this.runner, params)
      }

      return promise.then(this.enhanceListData).then((data) => {
        this.loading = false
        this.videosList = data
        return data
      })
    },
    changeVideo (item) {
      this.$set(item, 'edit', true)
    },
    removeVideo (item) {
      this.$root.$confirm('Usuń wideo', 'Czy na pewno usunąć wideo?', {confirmText: 'Usuń', color: 'error'}).then((willDelete) => {
        if (willDelete) {
          let promise
          if (this.isAdmin) {
            promise = deleteAdminVideo(item)
          } else if (this.isTrainer) {
            promise = deleteTrainerVideo(this.trainer, item)
          }
          return promise.then(() => {
            this.refresh()
            iziToast.show({
              message: 'Film został usunięty',
              color: 'green'
            })
          }).catch(() => {
            iziToast.show({
              message: 'Nie udało się usunąć filmu.',
              color: 'red'
            })
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/videos/Videos.vue